import React, { useState } from "react";

const InvoiceItemTableRow = (props) => {

    const [showDetails, setShowDetails] = useState(false);

    const toggleDetails = () => {
        setShowDetails(!showDetails);
    }

    const detailsTable = props.details.map(detail => {
        var dt = new Date(detail.date_created);
        return (
        <tr key={detail.content_hash + detail.date_created}>
            <td>{dt.getMonth() + 1}/{dt.getDate()}</td>
            <td>
                <a href={detail.content_hash} rel="noopener noreferrer" target="_blank">
                    {decodeURIComponent(detail.title).substr(0, 50)}{decodeURIComponent(detail.title).length > 50 ? '...' : ''}
                </a>
            </td>
            <td className="text-center">{detail.percent_consumed}%</td>
            <td className="text-right">${detail.charged.toFixed(2)}</td>
        </tr>);
    });

  
    return (<>
        <tr className="domain-row" onClick={() => toggleDetails()}>
            <td style={{width: "60px"}}>
                <div className="flag">
                <img style={{height:"30px"}} src={props.favicon_url} alt="business logo" />
                </div>
            </td>
            <td>{props.name}</td>
            <td style={{width: "60px"}} className="text-center">{props.total_content}</td>
            <td style={{width: "60px"}} className="text-right">${props.total_charged.toFixed(2)}</td>
        </tr>
        {showDetails ? detailsTable : <></> }
            
        
    </>);

}
export default InvoiceItemTableRow;

